import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle, Loader2, MailWarning } from "lucide-react";

import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function VerifyEmail() {
  const { token } = useParams();
  const { refresh } = useAuth();
  const [state, setState] = useState({ status: "loading", message: "Verifying your email…" });

  useEffect(() => {
    let active = true;
    api.post(`/auth/verify-email/${encodeURIComponent(token || "")}`)
      .then(async () => {
        await refresh();
        if (active) setState({ status: "success", message: "Your email is verified." });
      })
      .catch((err) => {
        if (active) setState({ status: "error", message: formatApiError(err) });
      });
    return () => { active = false; };
  }, [token, refresh]);

  const success = state.status === "success";
  return (
    <main className="max-w-lg mx-auto px-4 py-16 text-center" data-testid="verify-email-page">
      <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        {state.status === "loading" ? (
          <Loader2 className="w-10 h-10 mx-auto text-emerald-700 animate-spin" aria-hidden="true" />
        ) : success ? (
          <CheckCircle className="w-10 h-10 mx-auto text-emerald-700" aria-hidden="true" />
        ) : (
          <MailWarning className="w-10 h-10 mx-auto text-amber-700" aria-hidden="true" />
        )}
        <h1 className="mt-4 font-display text-2xl font-bold">
          {success ? "Email verified" : state.status === "loading" ? "Verifying email" : "Verification failed"}
        </h1>
        <p className="mt-2 text-sm text-slate-600" role={state.status === "error" ? "alert" : "status"}>
          {state.message}
        </p>
        <Link to={success ? "/portal" : "/login"} className="mt-6 inline-flex px-5 py-2.5 rounded-lg btn-brand text-sm font-medium">
          {success ? "Open My Bookings" : "Return to login"}
        </Link>
      </div>
    </main>
  );
}
